<template>
 <div>
 </div>
</template>

<script>
    export default {
        mounted() {
            Inputmask().mask('input');
        },
        data(){
            return {
            }
        },
        methods: {

        }

    }
</script>
